export const REDSHIFT_MEMBER_FIELDS = [
    'pk_id',
    'name',
    'first_name',
    'last_name',
    'email',
    'birthdate'
];
export const REDSHIFT_MEMBER_FIELDS_EMAIL = [
    'pk_id',
    'name',
    'first_name',
    'last_name',
    'email',
    'birthdate',
    'type',
    'id_betis'
];

export const REDSHIFT_MEMBER_PIN_FIELD = ['pin'];

